import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ProductsSummary } from '../../../models/products.model';

@Component({
	selector: 'app-products-modal',
	styleUrls: ['./products-modal.component.scss'],
	templateUrl: './products-modal.component.html',
})
export class ProductsModalComponent implements OnInit {
	filterProductsControl = new UntypedFormControl('');
	products: ProductsSummary[] = [];
	selectedProducts: string[] = [];

	constructor(
		public dialogRef: MatDialogRef<ProductsModalComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			products: ProductsSummary[];
			selectedProducts: string[];
		},
	) {}

	closeModal() {
		this.dialogRef.close();
	}

	filterProductsList() {
		const filterValue = this.filterProductsControl.value.toLowerCase();
		this.data.products = this.products;
		if (filterValue) {
			this.data.products = this.data.products.filter((product) =>
				product.name.toLowerCase().includes(filterValue),
			);
		}
	}

	masterSelection(): boolean {
		return this.selectedProducts.length === this.data.products.length;
	}

	ngOnInit(): void {
		this.products = this.data.products;
		this.selectedProducts = this.data.selectedProducts;
	}

	onMasterToggle(): void {
		if (this.masterSelection()) {
			this.selectedProducts = [];
		} else {
			const all = this.data.products.map((p) => p.id);
			this.selectedProducts = all;
		}
	}

	onPositionToggle(id: string, checked: boolean): void {
		if (!checked) {
			this.selectedProducts.splice(
				this.selectedProducts.findIndex((i) => id === i),
				1,
			);
		} else {
			this.selectedProducts.push(id);
		}
	}

	saveProducts(): void {
		const result = this.data.products.filter((p) =>
			this.selectedProducts.includes(p.id),
		);
		this.dialogRef.close(result);
	}
}
